var _effectorFileName = "/src/shared/components/animation/magic-container/magic-card.tsx";
import { CSSProperties, ReactElement, ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
interface MagicCardProps {
  /**
   * @default <div />
   * @type ReactElement
   * @description
   * The component to be rendered as the card
   * */
  as?: ReactElement;
  /**
   * @default ""
   * @type string
   * @description
   * The className of the card
   */
  className?: string;

  /**
   * @default ""
   * @type ReactNode
   * @description
   * The children of the card
   * */
  children?: ReactNode;

  /**
   * @default 600
   * @type number
   * @description
   * The size of the spotlight effect in pixels
   * */
  size?: number;

  /**
   * @default true
   * @type boolean
   * @description
   * Whether to show the spotlight
   * */
  spotlight?: boolean;

  /**
   * @default "rgba(255,255,255,0.03)"
   * @type string
   * @description
   * The color of the spotlight
   * */
  spotlightColor?: string;

  /**
   * @default true
   * @type boolean
   * @description
   * Whether to isolate the card which is being hovered
   * */
  isolated?: boolean;

  /**
   * @default "rgba(255,255,255,0.03)"
   * @type string
   * @description
   * The background of the card
   * */
  background?: string;
  [key: string]: any;
}
export const MagicCard = (props: MagicCardProps) => {
  const {
    className,
    children,
    size = 120,
    spotlight = true,
    borderColor = 'hsl(0 0% 98%)',
    isolated = true,
    ...otherProps
  } = props;
  return <div style={{
    '--mask-size': `${size}px`,
    '--border-color': `${borderColor}`
  } as CSSProperties} className={cn('relative z-0 h-full w-full rounded-2xl p-6', 'bg-gray-300 dark:bg-gray-700', 'bg-[radial-gradient(var(--mask-size)_circle_at_var(--mouse-x)_var(--mouse-y),var(--border-color),transparent_100%)]', className)} {...otherProps}>
      {children}

      {/* Background */}
      <div className={'absolute inset-[1px] -z-20 rounded-2xl bg-white dark:bg-black/95'} />
    </div>;
};